<template>
  <div class="programme-banner">
    <img :src="mobileprogrammeBanner" alt="" />
    <div class="absolute">
      <div class="title">智慧物业一站式解决方案</div>
      <div class="text">物业管理新升级 社区生活更美好 为物业赋能降本增效</div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../components/mobile/components/Experience.vue";

import mobileprogrammeBanner from "../../../assets/programme/mobileprogrammeBanner.png";

export default {
  setup() {
    return reactive({
      mobileprogrammeBanner: mobileprogrammeBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.programme-banner {
  position: relative;
}
.programme-banner img {
  width: 100%;
  height: 160px;
}
.absolute {
  width: 92vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
}
.absolute .title {
  font-size: 20px;
  color: #248EFB;
}
.absolute .text {
  font-size: 12px;
  margin-top: 12px;
  color: #248EFB;
}
.absolute .experience {
  margin: 0 auto;
  margin-top: 32px;
  color: #248EFB;
  border: 1px solid #248EFB;
  text-align: center;
  cursor: pointer;
  width: 72px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 20px 20px 20px 20px;
}
</style>
